export function getFormDataForSubmission(e: { nativeEvent: Event; currentTarget: HTMLFormElement }): FormData {
  const payload = new FormData(e.currentTarget)
  const submitter = (e.nativeEvent as SubmitEvent)?.submitter as HTMLButtonElement | HTMLInputElement | null | undefined

  if (submitter && submitter.type === 'submit' && submitter.name !== '') {
    payload.append(submitter.name, submitter.value)
  }

  return payload
}
